/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_WordInputs */

const en_lesson_word = /** @type {(inputs: Lesson_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lesson`)
};

const he_lesson_word = /** @type {(inputs: Lesson_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שיעור`)
};

/**
* | output |
* | --- |
* | "Lesson" |
*
* @param {Lesson_WordInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_word = /** @type {((inputs?: Lesson_WordInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_WordInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_word(inputs)
	return he_lesson_word(inputs)
});